var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelPhoto = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 54,
  viewBox: "0 0 60 54",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M6.67 3.333A3.344 3.344 0 0 0 3.333 6.69v39.955A3.34 3.34 0 0 0 6.67 50h46.66c1.843 0 3.337-1.5 3.337-3.356V6.689a3.34 3.34 0 0 0-3.337-3.356zM53.33 0C57.028 0 60 2.997 60 6.69v39.954c0 3.692-2.981 6.69-6.67 6.69H6.67c-3.698 0-6.67-2.998-6.67-6.69V6.689C0 3.076 2.856.128 6.435.004L6.67 0zM20.833 17.667 8 34.167v11.166h44V36L41 23.167l-5.5 5.5 5.5 11zM45 10a5 5 0 1 0 0 10 5 5 0 0 0 0-10"
})));
export default SvgChannelPhoto;